import HomeLogo from "../HomeLogo";
import FloatUp from "../shared/FloatUp";
import ExpandOnHover from "../shared/ExpandOnHover";
import Typewriter from "typewriter-effect";
import Loader from "../shared/Loader";
import { FaPlay } from "react-icons/fa";
import AppContext from "../../context/Context";
import { getHomeContent } from "../../context/Actions";
import { useEffect, useContext } from "react";
import AnnouncementList from "../AnnouncementList";

export default function Content() {
  const { isLoading, dispatch, links, quotes, announcements } =
    useContext(AppContext);

  useEffect(() => {
    dispatch({ type: "SET_LOADING" });
    const fetchHomecontent = async () => {
      const fetchedHomeContent = await getHomeContent();
      dispatch({ type: "GET_HOME_CONTENT", payload: fetchedHomeContent });
    };
    fetchHomecontent();
  }, [dispatch]);

  if (isLoading) return <Loader />;

  return (
    <FloatUp>
      <main className="section">
        <div className="min-vh-90">
          <div className="section main-section">
            <div className="is-flex is-justify-content-space-between">
              <div className="content" style={{ width: "853px" }}>
                <h1 className="title main-title is-2">
                  Computer Science and Engineering Association
                </h1>
                <p className="quote">
                  This an official website of the Computer Science and
                  Engineering Association of NIT Andhra Pradesh.
                </p>
                <div className="mt-6">
                  <a
                    className="button is-large is-success mx-2 main-button"
                    href="#announcements"
                  >
                    Highlights
                  </a>
                  <a
                    className="button is-large is-info mx-2 main-button"
                    href="#announcements"
                  >
                    latest updates
                  </a>
                </div>
              </div>
              <div className="content">
                <HomeLogo />
              </div>
            </div>
          </div>
          <section className="section">
            <div className="section main-quote has-background-light">
              <div className="subtitle is-italic has-text-weight-semibold">
                <Typewriter
                  options={{
                    strings: quotes,
                    autoStart: true,
                    loop: true,
                    delay: 40,
                    deleteSpeed: 5,
                  }}
                />
              </div>
            </div>
          </section>
        </div>
        <section className="section">
          <h2 className="title">Announcements &amp; Updates</h2>
          <div id="announcements">
            <AnnouncementList announcements={announcements} />
          </div>
        </section>
        <section className="section">
          <h2 className="title">Trending youtube</h2>
          <div className="is-flex is-align-items-center">
            <div className="level table-container">
              {links.map((link) => (
                <div key={link._id} className="level-item m-2">
                  <ExpandOnHover>
                    <div
                      className="is-flex is-flex-wrap-wrap is-justify-content-center is-align-items-center"
                      style={{
                        width: "320px",
                        height: "180px",
                        backgroundImage: `url(${link.imgURL})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    >
                      <a href={link.link}>
                        <ExpandOnHover>
                          <FaPlay size="40" color="white" />
                        </ExpandOnHover>
                      </a>
                    </div>
                  </ExpandOnHover>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="section">
          <h2 className="mt-6 mx-3 title">About us</h2>
          <div className="m-4">
            The Computer Science and Engineering Association (CSEA) is an
            integral part of the Computer Science and Engineering Department of
            NIT Andhra Pradesh. Over the years, CSEA has encouraged the academic
            and scientific development of the department's student body through
            activities such as coding competitions, technical workshops , GRE
            Sessions , Placement Talks and many more.
          </div>
        </section>
      </main>
    </FloatUp>
  );
}
